/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2021 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

class FeatureFlagsUtils {

	static setFeatureFlags(featureFlags) {
		this.featureFlags = featureFlags;
	}

	static getAllFeatureFlags() {
		if (this.featureFlags) {
			return this.featureFlags;
		}
		return [];
	}

	static hasFeature(feature) {
		if (this.featureFlags) {
			return this.featureFlags.includes(feature);
		}
		return false;
	}
};

export default FeatureFlagsUtils;